'use client';

import { AssetType as InlineAssetType } from '@/inline-playlist/src/types/AssetType';
import {
  ANIMATED_IMAGE_LOCATION,
  ANIMATED_VERTICAL_IMAGE_LOCATION,
} from '@/util/constants';
import {
  AssetType,
  CuratedAssetType,
} from '@vimond/services/content-discovery';
import { ReactNode } from 'react';
import { Artwork } from '../images/Artwork';

type PropsType = {
  asset: InlineAssetType | AssetType | CuratedAssetType;
  alt?: string;
  children?: ReactNode;
  containerClass?: string;
  isVertical?: boolean;
  onPreviewError?: () => void;
  previewImageClass?: string;
};

const AnimatedPreview = ({
  alt = 'Preview image',
  asset,
  containerClass = '',
  isVertical = false,
  onPreviewError,
  previewImageClass = '',
}: PropsType) => {
  const animatedImageUrl =
    'content' in asset && asset.content !== undefined
      ? asset.content.images?.defaultUrl
      : asset.images?.defaultUrl;

  if (!animatedImageUrl) return null;

  return (
    <div className={containerClass}>
      <Artwork
        className={`object-cover object-center ${previewImageClass}`}
        src={animatedImageUrl}
        location={
          isVertical
            ? ANIMATED_VERTICAL_IMAGE_LOCATION
            : ANIMATED_IMAGE_LOCATION
        }
        title=""
        alt={alt}
        fill
        onLoadError={onPreviewError}
        unoptimized // image animation not working with optimization
      />
    </div>
  );
};

export default AnimatedPreview;
